// getters
const controlaccesoqracces = state => state.controlaccesoqracces

export default {
  controlaccesoqracces
}



// WEBPACK FOOTER //
// ./src/store/modules/controlacceso/qracces/getters.js